import {classes} from './MainLoader.st.css';
import React from 'react';
import {SkeletonSection} from '../../Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum MainLoaderDataHook {
  Loader = 'MainLoaderDataHook.Loader',
  OldLoader = 'MainLoaderDataHook.OldLoader',
}

export const MainLoader = () => {
  return (
    <div className={classes.root} data-hook={MainLoaderDataHook.Loader}>
      <SkeletonSection>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.xl} />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.medium} />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.small} />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.large} />
        </SkeletonRow>
      </SkeletonSection>
    </div>
  );
};
